import SectionTitle from "@/components/ui/section-title";
import Image from "next/image";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import ImageCard from "../../ui/image_card/imgCard";

import SwiperPagination from "@/components/ui/swiper/swiper-pagination";
import { MEDIA_BASE_URL } from "@/utils/api";

const Application_Details = ({ centerClass, applicationDetails }) => {
  const mediaBaseUrl = MEDIA_BASE_URL;
  const applicationData = applicationDetails?.data || [];

  return (
    // Check if any data (title, description, or slider data) exists before rendering the component
    <>
      {(applicationDetails?.title ||
        applicationDetails?.desc ||
        applicationData.length > 0) && (
        <div className={`mb-5 lg:mb-0 ${centerClass}`}>
          {/* Conditionally render title and description */}
          {(applicationDetails?.title || applicationDetails?.desc) && (
            <div className="mx-auto lg:max-w-[40vw] mb-5 lg:mb-[2.5vw]">
              {applicationDetails?.title && (
                <SectionTitle
                  customClass={"mb-4 lg:mb-[1vw]"}
                  title={applicationDetails.title}
                />
              )}
              {applicationDetails?.desc && <p>{applicationDetails.desc}</p>}
            </div>
          )}

          {/* Conditionally render Swiper slider if there is data */}
          {applicationData.length > 0 && (
            <>
              <Swiper
                slidesPerView={1}
                slidesPerGroupSkip={3}
                spaceBetween={35}
                speed={2000}
                loop={false}
                pagination={{
                  clickable: true,
                  el: ".application-pagination",
                }}
                autoplay={{
                  delay: 1500,
                  disableOnInteraction: false,
                }}
                modules={[Pagination]}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                  1024: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                  },
                }}
                className="h-full bathwareProductDetails"
              >
                {applicationData.map((item, i) => (
                  <SwiperSlide key={i} className="h-full">
                    <ImageCard
                      imgSrc={`${mediaBaseUrl}${item.image}`}
                      title={item.name}
                      imgClass={`h-[43px] lg:max-h-[3.1vw] !max-w-[100%] w-auto mx-auto`}
                      customClass={`text-center font-secondary text-black`}
                      hrefUrl={""}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
              <SwiperPagination customClass={"application-pagination"} />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default Application_Details;
